import React, { memo } from 'react';
import { Phone, MapPin } from 'lucide-react';
import { partners, sedeImage, company } from '../mock';

const PartnersAndSede = () => {
  const list = [...partners, ...partners];
  return (
    <section className="py-20 md:py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <h2 className="font-display text-3xl md:text-5xl font-bold text-center text-brand-navy uppercase title-underline">
          I Nostri Partner Assicurativi
        </h2>

        <div className="mt-12 marquee-wrap overflow-hidden">
          <div className="marquee-track items-center">
            {list.map((p, i) => (
              <div key={`${p.name}-${i}`} className="shrink-0 h-20 w-40 flex items-center justify-center grayscale hover:grayscale-0 transition-all opacity-70 hover:opacity-100">
                <img src={p.logo} alt={`Logo ${p.name} - partner assicurativo Magic Deumidificazioni`} loading="lazy" decoding="async" width="160" height="56" className="max-h-14 max-w-full object-contain" />
              </div>
            ))}
          </div>
        </div>

        <p className="text-center text-gray-600 mt-8">Collaboriamo con le principali compagnie assicurative svizzere</p>
        <div className="flex justify-center mt-6">
          <a href={`tel:${company.phoneRaw}`} className="inline-flex items-center gap-2 text-brand-navy font-display text-xl font-bold border-2 border-brand-navy hover:bg-brand-navy hover:text-white transition-colors px-6 py-3 rounded-md">
            <Phone className="w-5 h-5" />
            {company.phone}
          </a>
        </div>

        <div className="mt-20 rounded-xl overflow-hidden shadow-2xl">
          <div className="bg-brand-navy text-white text-center py-5">
            <h3 className="font-display text-2xl md:text-3xl font-bold uppercase tracking-wide">La Nostra Sede</h3>
          </div>
          <div className="relative h-72 md:h-96">
            <img src={sedeImage} alt="Sede Magic Deumidificazioni a Mezzovico, Ticino" loading="lazy" decoding="async" width="1200" height="800" sizes="(max-width: 768px) 100vw, 50vw" className="w-full h-full object-cover" />
            <div className="absolute inset-0 bg-gradient-to-r from-brand-navy/70 via-brand-navy/20 to-transparent flex items-center">
              <div className="px-8 md:px-16 text-white">
                <h4 className="font-display text-3xl md:text-5xl font-bold uppercase tracking-wide">L&rsquo;Azienda</h4>
                <div className="mt-5 flex items-start gap-3">
                  <MapPin className="w-5 h-5 mt-1 text-brand-red" />
                  <div>
                    <p className="font-semibold text-lg">{company.address}</p>
                    <p className="text-white/85">{company.city}</p>
                    <a href={company.mapsLink} target="_blank" rel="noreferrer" className="inline-block mt-3 text-sm font-semibold text-brand-red hover:underline">
                      Apri in Google Maps →
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <iframe
            title="Mappa sede Magic Deumidificazioni Via San Mamete 78 Mezzovico"
            src="https://www.google.com/maps?q=Via+San+Mamete+78,+6805+Mezzovico&output=embed"
            className="w-full h-72 md:h-96 border-0"
            loading="lazy"
            referrerPolicy="no-referrer-when-downgrade"
          />
        </div>
      </div>
    </section>
  );
};

export default memo(PartnersAndSede);
